import {useEffect} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import cookie from 'react-cookies'

export default function Initor(){
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  useEffect(()=>{
    let token = searchParams.get('tkn')
    if (token) {
      cookie.save('_tkn_', token)
      navigate('/course/list')
    } else {
      navigate('unauthorized')
    }
  },[])

  return (<div>Loading</div>)
}